import { DocumentService } from '@fi-app/document/document.service';

export const FiDocumentStatesResolveDefaultDocumentSettings = [
    DocumentService,
    FiDocumentStatesResolveDefaultDocumentSettingsResolveFunc,
];

export function FiDocumentStatesResolveDefaultDocumentSettingsResolveFunc(documentService: DocumentService) {
    return documentService.GetDefaultSetting();
}
